import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Fab } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { t } from 'utils/i18n';
import styles from './EditButton.module.css';

const EditButton = (props) => {
  const { className, ...other } = props;

  return (
    <Fab className={cn(styles.fab, className)} {...other}>
      <EditIcon />
    </Fab>
  );
};

EditButton.propTypes = {
  color: Type.oneOfType([Type.oneOf(['inherit', 'primary', 'secondary']), Type.string]),
  className: Type.string,
  'aria-label': Type.string,
};

EditButton.defaultProps = {
  'aria-label': t('edit'),
  color: 'primary',
  className: undefined,
};

export default EditButton;
